export default ({ app }) => {
    if (process.client) {
        window.$toast = app.$toast;

        // make Nuxt loading bar available globally
        Object.defineProperty(window, '$loading', {
            get() {
                // $nuxt may not be ready immediately, so use a getter
                return window.$nuxt?.$root?.$loading;
            }
        });
    }


};
